import { combineReducers } from "redux";
import cartReducer from "./cart/cartSlice";
import productReducer from "./menu/productsSlice";
import serviceReducer from "./menu/servicesSlice";
import detailsReducer from "./userInfo/detailsSlice";
import businessReducer from "./business/businessSlice"

const rootReducer = combineReducers(
    {
        business: businessReducer,
        cart: cartReducer,
        products: productReducer,
        services: serviceReducer,
        details: detailsReducer, // Use 'details' as the key here
    }
);

export default rootReducer;